import { target, targetable } from '@github/catalyst/lib/targetable'

export default targetable(class extends HTMLElement {
  static [target.static] = ['defaultButton', 'loadingButton']

  connectedCallback () {
    this.addEventListener('click', () => this.downloadFiles())
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        this.downloadFiles()
      }
    })
  }

  toggleState () {
    this.defaultButton?.classList?.toggle('hidden')
    this.loadingButton?.classList?.toggle('hidden')
  }

  // Synexis (Onda 4): os dois ramos de FALHA nao devolviam o botao ao estado normal.
  //
  // O caminho feliz sempre reverteu, porque `downloadUrls` e `downloadSafariIos` tem
  // `.finally(() => this.toggleState())`. Faltava:
  //   - resposta nao-ok: mostrava o toast e deixava o botao presa em "Baixando..." para sempre;
  //   - rejeicao do fetch (rede caiu, DNS, CORS): sem `.catch`, a promise morria sem tratamento --
  //     o signatario ficava com o spinner girando e NEM o toast aparecia.
  //
  // Isso e a ultima tela do fluxo de assinatura: quem chega aqui ja assinou, e o unico recurso era
  // recarregar a pagina.
  downloadFiles () {
    if (!this.dataset.src) return

    this.toggleState()

    fetch(this.dataset.src).then(async (response) => {
      if (!response.ok) {
        this.failDownload()

        return
      }

      const urls = await response.json()
      const isMobileSafariIos = 'ontouchstart' in window && navigator.maxTouchPoints > 0 && /AppleWebKit/i.test(navigator.userAgent)
      const isSafariIos = isMobileSafariIos || /iPhone|iPad|iPod/i.test(navigator.userAgent)

      if (isSafariIos && urls.length > 1) {
        this.downloadSafariIos(urls)
      } else {
        this.downloadUrls(urls)
      }
    }).catch(() => this.failDownload())
  }

  // Reverte o estado E avisa. A mensagem vem por data attribute (padrao de `wizard_signers.js` e
  // `contacts_picker.js`) porque estava cravada em ingles no meio do JS -- o resto da tela do
  // signatario e traduzido. O fallback existe para as instancias que ainda nao passem o atributo.
  failDownload () {
    this.toggleState()

    window.Toast?.error(this.dataset.errorText || 'Failed to download files')
  }

  downloadUrls (urls) {
    const fileRequests = urls.map((url) => {
      return () => {
        return fetch(url).then(async (resp) => {
          const blobUrl = URL.createObjectURL(await resp.blob())
          const link = document.createElement('a')

          link.href = blobUrl
          link.setAttribute('download', decodeURI(url.split('/').pop()))

          link.click()

          URL.revokeObjectURL(blobUrl)
        })
      }
    })

    fileRequests.reduce(
      (prevPromise, request) => prevPromise.then(() => request()),
      Promise.resolve()
    ).finally(() => {
      this.toggleState()
    })
  }

  downloadSafariIos (urls) {
    const fileRequests = urls.map((url) => {
      return fetch(url).then(async (resp) => {
        const blob = await resp.blob()
        const blobUrl = URL.createObjectURL(blob.slice(0, blob.size, 'application/octet-stream'))
        const link = document.createElement('a')

        link.href = blobUrl
        link.setAttribute('download', decodeURI(url.split('/').pop()))

        return link
      })
    })

    Promise.all(fileRequests).then((links) => {
      links.forEach((link, index) => {
        setTimeout(() => {
          link.click()

          URL.revokeObjectURL(link.href)
        }, index * 50)
      })
    }).finally(() => {
      this.toggleState()
    })
  }
})
